import { useEffect, useState } from 'react'

export function useCheckLocalStorageItemExistance(key: string) {
  const [state, setState] = useState(false)

  useEffect(() => {
    const stored = localStorage.getItem(key)

    if (stored !== null) {
      setState(true)
    }
  }, [key])

  return state
}
